export default "__VITE_ASSET__BtWSrW4g__"